// extracted by mini-css-extract-plugin
export default {"GenericIcon":"GenericIcon_GenericIcon__fBU31"};